import { render, staticRenderFns } from "./SendCaptcha.vue?vue&type=template&id=b9f36608&scoped=true&"
import script from "./SendCaptcha.vue?vue&type=script&lang=js&"
export * from "./SendCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./SendCaptcha.vue?vue&type=style&index=0&id=b9f36608&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f36608",
  null
  
)

export default component.exports